import React from 'react';
// import { Link } from 'react-router-dom';
import {
  MDBContainer,
  MDBCol,
  MDBBtn,
  MDBInput,
  MDBCollapse,
  MDBRow,
  MDBIcon,
  MDBTooltip,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBSpinner,
  MDBAnimation,
  MDBSelect,
  MDBSwitch,
  MDBFileInput,
} from 'mdbreact';

import { format } from 'date-fns';
import { Link } from 'react-router-dom';

import { getData } from '../../../services/auth';
import { useState } from 'react';
import { useEffect } from 'react';
// import { compareAsc } from 'date-fns';

import api from '../../../services/api';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { de } from 'date-fns/locale';

export function AddDenuncia({ openModal, addAbreModal, buscaDenuncias, denuncia }) {
  const [listaClassificacao, setListaClassificacao] = useState([]);
  const [classificacaoSelecionada, setClassificacaoSelecionada] = useState(null);
  const [loading, setLoading] = useState(false);
  const [listanivelSigilo, setListaNivelSigilo] = useState([]);
  const [nivelSigiloSelecionado, setNivelSigiloSelecionado] = useState(null);
  const [switchDenunciaAnonima, setSwitchDenunciaAnonima] = useState(true);

  const [nomeDenunciante, setNomeDenunciante] = useState('');
  const [contatoDenunciante, setContatoDenunciante] = useState('');
  const [denunciaTexto, setDenunciaTexto] = useState('');
  const [arquivo, setArquivo] = useState(null);
  const [arquivoNome, setArquivoNome] = useState('');
  const [deleteArquivo, setDeleteArquivo] = useState(false);

  const buscaClassificacao = async () => {
    const resultSelect = [];
    const result = await api.get('/dd-classificacao');
    result.data.forEach(element => {
      resultSelect.push({ label: element.classificacao, value: element.id });
    });
    setListaClassificacao(resultSelect);
  };
  const buscaNivelSigilo = async () => {
    const resultSelect = [];
    const result = await api.get('/dd-nivel-sigilo');
    result.data.forEach(element => {
      resultSelect.push({ label: element.nivel_sigilo, value: element.id });
    });
    setListaNivelSigilo(resultSelect);
  };

  // Pre-fill form when editing
  useEffect(() => {
    if (denuncia) {
      setClassificacaoSelecionada({
        label: denuncia.dd_classificacao?.classificacao,
        value: denuncia.dd_classificacao?.id,
      });
      setNivelSigiloSelecionado({
        label: denuncia.dd_nivel_sigilo?.nivel_sigilo,
        value: denuncia.dd_nivel_sigilo?.id,
      });
      setSwitchDenunciaAnonima(!denuncia.dd_denunciante?.nome); // Anonymous if no name
      setNomeDenunciante(denuncia.dd_denunciante?.nome || '');
      setContatoDenunciante(denuncia.dd_denunciante?.contato || '');
      setDenunciaTexto(denuncia.denuncia || '');
      setArquivoNome(
        denuncia.dd_denuncia_pdfs?.length > 0
          ? denuncia.dd_denuncia_pdfs[0].nome
          : ''
      );
    } else {
      // Reset form for creation
      setClassificacaoSelecionada(null);
      setNivelSigiloSelecionado(null);
      setSwitchDenunciaAnonima(true);
      setNomeDenunciante('');
      setContatoDenunciante('');
      setDenunciaTexto('');
      setArquivo(null);
      setArquivoNome('');
    }
  }, [denuncia]);

  // Fetch options when modal opens
  useEffect(() => {
    if (openModal) {
      buscaClassificacao();
      buscaNivelSigilo();
    }
  }, [openModal]);

  useEffect(() => {
    if (arquivo) {
      setArquivoNome(arquivo.name);
    } else {
      setArquivoNome('');
    }
  }, [arquivo]);
  const enviarDenuncia = async () => {
    const dados = {};
    if (classificacaoSelecionada === null) {
      toast.error('Classificação não selecionada');
      return;
    }
    dados.dd_classificacao_id = classificacaoSelecionada.value;

    if (nivelSigiloSelecionado === null) {
      toast.error('Nivel de Sigilo não selecionado');
      return;
    }
    dados.dd_nivel_sigilo_id = nivelSigiloSelecionado.value;

    if (switchDenunciaAnonima === false) {
      if (nomeDenunciante === '') {
        toast.error('Preencha o Nome do Denunciante');
        return;
      }
      dados.nome = nomeDenunciante;

      if (contatoDenunciante === '') {
        toast.error('Preencha o Contato do Denunciante');
        return;
      }
      dados.contato = contatoDenunciante;
    } else {
      dados.nome = '';
      dados.contato = '';
    }
    if (denunciaTexto === '') {
      toast.error('Preencha a Denuncia');
      return;
    }
    dados.denuncia = denunciaTexto;
    setLoading(true);
    try {
      let denuncia_id = null;
      let tipo = 'criada';
      // If editing, use existing denuncia
      if (denuncia && denuncia.id) {
        tipo = 'alterada';
        denuncia_id = await denuncia.id;
        await api.put(`/dd-denuncia/${denuncia.id}`, dados);
      } else {
        denuncia = await api.post('/dd-denuncia', dados);
        denuncia_id = await denuncia.data.denuncia.id;  
      }
      denuncia_id = parseInt(denuncia_id, 10);

      // If deleting existing file, remove it first
      if (deleteArquivo && denuncia?.dd_denuncia_pdfs?.length > 0)
      {
        await api.delete(`/dd-denuncia/${denuncia_id}/pdf`);
      }
      // If a new file is provided, upload it
      if (arquivo && denuncia_id) {
        const formData = new FormData();
        formData.append('denuncia_id', denuncia_id);
        formData.append('file', arquivo);
        const response = await api.post(`/dd-denuncia/${denuncia_id}/upload`, formData);
      }
      toast.success(`Denúncia ${tipo} com sucesso`);
      addAbreModal(false, null); // Close modal and clear selected denuncia
      setLoading(false);
      setArquivo(null);
      buscaDenuncias();
    } catch (error) {
      toast.error('Denuncia não pôde ser criado', error.message);
      console.error('Erro ao enviar denúncia:', error);
      setArquivo(null);
      setLoading(false);
    }
  };

  return (
    <MDBModal
      size="lg"
      isOpen={openModal === true}
      toggle={() => {
        addAbreModal(false);
      }}
    >
      <MDBModalHeader toggle={() => addAbreModal(false)}>
        {denuncia ? 'Editar Denúncia' : 'Criar Nova Denúncia'}
      </MDBModalHeader>
      <MDBModalBody>
        <MDBRow>
          <MDBCol middle>
            <Select
              placeholder="Classificação"
              options={listaClassificacao}
              onChange={e => setClassificacaoSelecionada(e)}
              value={classificacaoSelecionada}
            />
          </MDBCol>
          <MDBCol middle>
            <Select
              placeholder="Nível de Sigilo"
              options={listanivelSigilo}
              onChange={e => setNivelSigiloSelecionado(e)}
              value={nivelSigiloSelecionado}
            />
          </MDBCol>
          {/* <MDBCol>
            <Select placeholder="Status" />
          </MDBCol> */}
          <MDBCol className="d-flex flex-column text-center">
            <div className="font-weight-bolder"> Denúncia Anônima </div>
            <MDBSwitch
              checked={switchDenunciaAnonima}
              onChange={() => setSwitchDenunciaAnonima(!switchDenunciaAnonima)}
              labelLeft="Não"
              labelRight="Sim"
            />

            {/* <MDBInput outline label="Denunciante" /> */}
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol>
            <MDBCollapse
              id="basicCollapse"
              isOpen={switchDenunciaAnonima === false}
            >
              <MDBRow>
                <MDBCol>
                  <MDBInput
                    outline
                    label="Nome do Denunciante"
                    onChange={e => setNomeDenunciante(e.target.value)}
                    value={nomeDenunciante}
                  />
                </MDBCol>
                <MDBCol>
                  <MDBInput
                    outline
                    label="Contato do Denunciante"
                    onChange={e => setContatoDenunciante(e.target.value)}
                    value={contatoDenunciante}
                  />
                </MDBCol>
              </MDBRow>
            </MDBCollapse>
          </MDBCol>
        </MDBRow>
        <MDBRow>
          <MDBCol>
            <MDBInput
              label="Descreva a Denúncia"
              outline
              rows="12"
              type="textarea"
              onChange={e => setDenunciaTexto(e.target.value)}
              value={denunciaTexto}
            />
          </MDBCol>
        </MDBRow>
        {/* excluir pdf se existir */}
        { arquivoNome ? (
          <MDBRow>
            <MDBCol>
              <MDBBtn
                color="danger"
                onClick={() => {setArquivoNome(''); setArquivo(null); setDeleteArquivo(true)}}
                size="sm"
              >
                Remover PDF
              </MDBBtn>
              <span>{arquivoNome}</span>  
            </MDBCol>
          </MDBRow>
        ) : (
          <MDBRow>
            <MDBCol>
              <MDBFileInput
                textFieldTitle='Arquivo PDF'
                btnTitle='Inserir'
                btnColor='default'
                value={arquivo}
                getValue={e => setArquivo(e[0])}
                accept="application/pdf"
              />
            </MDBCol>
          </MDBRow>
      )}

      </MDBModalBody>
      <MDBModalFooter>
        <MDBBtn
          color="danger"
          size="sm"
          onClick={() => addAbreModal(false, null)}
        >
          Cancelar
        </MDBBtn>
        <MDBBtn
          disabled={loading}
          onClick={() => enviarDenuncia()}
          color="green"
          size="sm"
        >
          {/* <MDBSpinner small /> */}
          {loading ? 'Enviando...' : 'Confirmar'}
        </MDBBtn>
      </MDBModalFooter>
    </MDBModal>
  );
}
